import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { LowerCasePipe } from '@angular/common';
import { SvgIconComponent } from '@shared/svg-icon/svg-icon.component';
import { TranslateSafePipe } from '@shared/translate-safe/translate-safe.pipe';

@Component({
    selector: 'app-product-energy-class',
    standalone: true,
    imports: [LowerCasePipe, SvgIconComponent, TranslateSafePipe],
    templateUrl: './product-energy-class.component.html',
    styleUrl: './product-energy-class.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductEnergyClassComponent {
    unitPrice = input<string | undefined>();
    energyEfficiencyClass = input<string | undefined>();
    energyEfficiencyProductSheetURL = input<string | undefined>();
}
